import script from "./dependents-incorporation-no-deliverable-form-expired.vue?vue&type=script&setup=true&lang=js"
export * from "./dependents-incorporation-no-deliverable-form-expired.vue?vue&type=script&setup=true&lang=js"

import "./dependents-incorporation-no-deliverable-form-expired.vue?vue&type=style&index=0&id=05c4e951&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c4e951"]])

export default __exports__